<script>
  import Modal from '@components/general/modal.svelte'
  import Block from '@components/general/block'
  import Button from '@components/buttons/button.svelte'
  import Text from '@components/general/text.svelte'
  import Dropdown from '@components/general/dropdown.svelte'
  import SentimentText from '@components/feedbacks/sentiment-text.svelte'
  import { formatDateTime } from '@lib/utils/date'
  import { Eye, EyeOff, MessageSquareReply, Trash2 } from 'lucide-svelte'

  let { open = $bindable(false), feedback, markRead, markUnread } = $props()

</script>

<Modal title="Feedback" bind:open avoidFocus>
  {#if feedback}
    <Block.Items class="mb-4">
      <Block.Item label="User" value={feedback.user.name} />
      <Block.Item label="Date" value={formatDateTime(feedback.created_at)} />
      <Block.Item label={feedback.feedbackable_type}>
        <Button variant="link" path={feedback.record.path} text={feedback.record.name || "View"} />
      </Block.Item>
      {#if feedback.sentiment}
        <Block.Item label="Opinion">
          <SentimentText sentiment={feedback.sentiment} />
        </Block.Item>
      {/if}
      <Block.Item label="Read" value={feedback.read_at ? formatDateTime(feedback.read_at) : "-"} />
      {#if feedback.read_by}
        <Block.Item label="Read by" value={feedback.read_by.name} />
      {/if}
      <Block.Item label="Message" column>
        <Text variant="long_text" class="mt-4 text-smaller">{feedback.message}</Text>
      </Block.Item>
    </Block.Items>
  {/if}

  {#snippet footer()}
    <Dropdown buttonProps={{ text: "Actions" }}>
      {#snippet contents(item)}
        {@render item({ text: "Mark as read", icon: Eye, onSelect: () => markRead(feedback) })}
        {@render item({ text: "Mark as unread", icon: EyeOff, onSelect: () => markUnread(feedback) })}
        {@render item({ text: "Reply", icon: MessageSquareReply, disabled: true })}
        {@render item({ text: "Delete", icon: Trash2, disabled: true })}
      {/snippet}
    </Dropdown>
  {/snippet}
  
</Modal>